import type { FieldMetadata } from '@/sections/insights/queryBuilder/entities/types';
import { camelCaseToLabel } from '@/sections/insights/queryBuilder/entities/utils/camelCaseToLabel';
import type { Schema } from '@/types';

/**
 * Extracts AWSResource fields from backend schema
 *
 * Filters to only filterable fields and transforms camelCase keys to labels.
 *
 * @param schema - The schema object from backend
 * @returns Array of field metadata (key + label)
 *
 * @example
 * const schema = useGetSchema();
 * const fields = getAWSResourceFields(schema.data);
 */
export function getAWSResourceFields(
  schema: Schema | undefined
): FieldMetadata[] {
  if (!schema || !schema.awsresource) {
    return [];
  }

  // Extract filterable fields from schema
  return Object.entries(schema.awsresource)
    .filter(([_, fieldSchema]) => fieldSchema.filterable)
    .map(([key, _]) => ({
      key,
      label: camelCaseToLabel(key),
    }))
    .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically
}
